import { yup } from "@utils/validation/validation";

export const gradeValidationSchema = yup.object().shape({
  score: yup.number().min(0).max(100).nullable().optional(),
  comments: yup.string().max(20000).nullable(),
  status: yup.string().required(),
});
